Pegasus.TextAreaView = Ember.TextArea.extend({
    inputDidChange: false,
    input: function() {
        var actionName = 'textareaChanged';
        var actions = this.get('targetObject').actions || this.get('targetObject')._actions;
        if (Ember.get(actions, actionName)) {
            this.set('inputDidChange', true);
            this.get('targetObject').send('textareaChanged', this.get('controller').value);
        }
    },
    click: function () {
        var actionName = 'textareaClicked';
        var actions =  this.get('targetObject').actions ||  this.get('targetObject')._actions;
        if(Ember.get(actions, actionName)) {
            this.get('targetObject').send('textareaClicked');
        }
    }
});